export const PRINTER_TYPE_BLUETOOTH = { id: 1, title: 'Bluetooth' };
export const PRINTER_TYPE_USB = { id: 2, title: 'USB' };
export const PRINTER_TYPE_WIFI = { id: 3, title: 'Wi-Fi' };

export const BLUETOOTH_PRINTER_TYPES = [
  { id: 1, title: 'Regular' },
  { id: 2, title: 'Star' },
];

export const WIFI_PRINTER_TYPES = [
  { id: 1, title: 'IP' },
  { id: 2, title: 'Star' },
];

export const DOCKET_PRINTER_TYPES = [
  {
    ...PRINTER_TYPE_BLUETOOTH,
    childTypes: BLUETOOTH_PRINTER_TYPES,
    childKey: 'bluetooth_printer_id',
  },
  PRINTER_TYPE_USB,
  {
    ...PRINTER_TYPE_WIFI,
    childTypes: WIFI_PRINTER_TYPES,
    childKey: 'network_printer_id',
  },
];

export const STICKER_PRINTER_TYPES = [
  {
    ...PRINTER_TYPE_BLUETOOTH,
    childTypes: BLUETOOTH_PRINTER_TYPES,
    childKey: 'bluetooth_printer_id',
  },
];

export const PRINTER_ROLL_58 = { id: 1, title: '58mm' };
export const PRINTER_ROLL_80 = { id: 2, title: '80mm' };
export const PRINTER_ROLLS = [PRINTER_ROLL_58, PRINTER_ROLL_80];

export const PRINTER_FONT_SIZES = [
  { id: 1, label: 'Small' },
  { id: 2, label: 'Normal' },
  { id: 3, label: 'Large' },
  { id: 4, label: 'Huge' },
];

export const PRINTER_PROFILE_TAB_GENERAL = {
  id: 1,
  title: 'General',
};

export const PRINTER_PROFILE_TAB_ADVANCED = {
  id: 2,
  title: 'Advanced',
};

export const PROFILE_TABS = [
  PRINTER_PROFILE_TAB_GENERAL,
  PRINTER_PROFILE_TAB_ADVANCED,
];

export const PRINTER_ROUTING_TAB_CATEGORY = {
  id: 1,
  title: 'Categories',
};

export const PRINTER_ROUTING_TAB_ITEM = {
  id: 2,
  title: 'Items',
};

export const PRINTER_ROUTING_TABS = [
  PRINTER_ROUTING_TAB_CATEGORY,
  PRINTER_ROUTING_TAB_ITEM,
];

export const STICKER_PRINTER_COMMAND_TYPE_ESC = { id: 1, title: 'ESC' };
export const STICKER_PRINTER_COMMAND_TYPE_NON_ESC = { id: 2, title: 'Non ESC' };

export const STICKER_PRINTER_COMMAND_TYPES = [
  STICKER_PRINTER_COMMAND_TYPE_ESC,
  STICKER_PRINTER_COMMAND_TYPE_NON_ESC,
];
